module.exports = __webpack_public_path__ + "static/media/advancedmaterials.1e13e614.svg";